import React from "react";
import "../../Styles/Pages/checkbox.scss";
import ToolTip from "../../HOC/ToolTip";

class Checkbox extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			id: "",
		};
	}

	componentDidMount() {
		if (!this.props.id) {
			this.setState({ id: `check${Math.random()}${new Date().getSeconds()}` });
		}
	}

	insertHtmlElement(html) {
		return { __html: html };
	}

	render() {
		return (
			<div className="form-checkbox">
				<div
					className="each-type checkbox-items"
					style={{
						padding: this.props.padding
							? this.props.padding
							: this.props.noPadding
							? ""
							: "15px 0px 5px",
					}}
				>
					<div className="form-check form-check-inline ">
						<input
							type="checkbox"
							readOnly={this.props.readOnly}
							id={this.props.id || this.state.id}
							className="checkbox__input"
							value={this.props.value}
							defaultValue={this.props.defaultValue}
							checked={this.props.checked}
							disabled={this.props.disabled}
							onChange={this.props.checkboxChange || this.props.onChange}
						/>
						<label
							htmlFor={this.props.id || this.state.id}
							className="checkbox-items__label"
							style={{
								display: "inline-block",
								position: "relative",
								top: "0px",
								left: "3px",
							}}
						>
							<span
								className="radio-data"
								style={{
									display: "block",
								}}
							>
								<span
									dangerouslySetInnerHTML={this.insertHtmlElement(
										this.props.label,
									)}
								/>
							</span>
						</label>
						{this.props.requiredStar && !this.props.tooltipText ? (
							<span
								style={{ color: "#ff0505", opacity: "0.7", paddingLeft: "4px" }}
							>
								*
							</span>
						) : null}
						{this.props.tooltipText && (
							<ToolTip
								adjustParentStyle={true}
								width={this.props.tooltipWidth || 170}
							>
								{this.props.tooltipText}
							</ToolTip>
						)}
					</div>
				</div>
			</div>
		);
	}
}

export default Checkbox;
